require('./bootstrap');
import Vue from 'vue';
window.VueEventBus = require('vue-event-bus');
VueEventBus = new Vue();

Vue.prototype.$http = window.axios;
Vue.prototype.$url = window.axios.defaults.baseURL;

Vue.component('dropdown-cart', () => import('./components/global/DropdownCart.vue'));
Vue.component('favourite-products-count', () => import('./components/global/FavouriteProductsCount.vue'));
Vue.component('favourite-products', () => import('./components/global/FavouriteProducts.vue'));
Vue.component('listing-filters', () => import('./components/listing/Filters.vue'));
Vue.component('cart-view', () => import('./components/cart/CartView.vue'));
Vue.component('vue-notification', () => import('./components/global/Notification.vue'));
Vue.component('dropdown-search', () => import('./components/global/dropdown-search/DropdownSearch.vue'));

new Vue({
    el: '#app'
});
